document.addEventListener("DOMContentLoaded", function () {
  //Video Modal
  const videoWrappers = document.querySelectorAll("[data-video-review-link]");
  const videoModal = document.getElementById("videoReviewsModal");
  const videoIframe = document.getElementById("videoReviewsIframe");
  const closeModal = document.querySelector(
    ".section-video-reviews__modal-close"
  );

  function openVideoModal(videoUrl) {
    embedUrl = `https://www.instagram.com/p/${videoUrl}/embed/`;
    videoIframe.src = embedUrl;
    videoModal.style.display = "flex";
  }

  function closeVideoModal() {
    videoIframe.src = "";
    videoModal.style.display = "none";
  }

  videoWrappers.forEach((wrapper) => {
    wrapper.addEventListener("click", () => {
      const videoUrl = wrapper.getAttribute("data-video-review-link");
      if (videoUrl) {
        openVideoModal(videoUrl);
      }
    });
  });

  closeModal.addEventListener("click", closeVideoModal);

  videoModal.addEventListener("click", (event) => {
    if (event.target === videoModal) {
      closeVideoModal();
    }
  });

  //Pagination
  let itemsPerPage = 4;
  let items = document.querySelectorAll(".section-video-reviews__item.hidden");
  let loadMoreBtn = document.getElementById("loadMoreBtn");

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {
      let hiddenItems = Array.from(items).slice(0, itemsPerPage);
      hiddenItems.forEach((item) => item.classList.remove("hidden"));

      items = document.querySelectorAll(".section-video-reviews__item.hidden");

      if (items.length === 0) {
        loadMoreBtn.style.display = "none";
      }
    });
  }

  //Review Wrap Open/Close
  const contentWraps = document.querySelectorAll(
    ".section-video-reviews__content-wrap"
  );

  contentWraps.forEach((contentWrap) => {
    const content = contentWrap.querySelector(
      ".section-video-reviews__review-wrap"
    );
    let isOpen = false;

    const openContent = () => {
      content.style.height = `${content.scrollHeight}px`;
      isOpen = true;
    };

    const closeContent = () => {
      content.style.height = "0";
      isOpen = false;
    };

    contentWrap.addEventListener("click", function (event) {
      if (window.innerWidth <= 1024) {
        if (isOpen) {
          closeContent();
        } else {
          openContent();
        }
      }
    });

    contentWrap.addEventListener("mouseenter", function () {
      if (window.innerWidth > 1024) {
        openContent();
      }
    });

    contentWrap.addEventListener("mouseleave", function () {
      if (window.innerWidth > 1024) {
        closeContent();
      }
    });
  });
});
